export default __webpack_public_path__ + "static/media/ICONO_PAGO.d52333f8.svg";